import { render } from "./DocumentCard.vue?vue&type=template&id=7823fdc2&scoped=true&ts=true"
import script from "./DocumentCard.vue?vue&type=script&lang=ts"
export * from "./DocumentCard.vue?vue&type=script&lang=ts"

import "./DocumentCard.vue?vue&type=style&index=0&id=7823fdc2&lang=sass&scoped=true"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7823fdc2"]])

export default __exports__